export default {
  meta: {
    title: '踩点记录详情' // 踩点记录详情
  }
};
